import React from 'react';

import Select from 'react-select';

import officerStatus from '@/data/officerStatus';
import { getCustomStyles } from '@/utils/customStyleSelect';

const SelectOfficerStatus: React.FC<any> = ({ name, value, defaultValue, handleChange, placeholder, hasError, isDisabled }) => {
    return (
        <Select
            name={name}
            value={officerStatus.find((option: any) => option.value === value)}
            onChange={handleChange}
            options={officerStatus}
            defaultValue={defaultValue}
            placeholder={placeholder}
            styles={getCustomStyles(hasError)}
            isDisabled={isDisabled}
        />
    );
};

export default SelectOfficerStatus;
